import { ClientRole, SessionState } from '../types';
import { getWsUrl } from './apiBase';

const PING_MS = 20000;

/** Открывает WebSocket сессии с автопереподключением и keepalive. */
export function connectSessionSocket(
  role: ClientRole,
  onState: (session: SessionState) => void
): () => void {
  let socket: WebSocket | null = null;
  let closed = false;
  let retryMs = 500;
  let retryTimer: ReturnType<typeof setTimeout> | null = null;
  let pingTimer: ReturnType<typeof setInterval> | null = null;

  /** Снимает обработчики и закрывает текущий сокет. */
  const dropSocket = () => {
    if (pingTimer) {
      clearInterval(pingTimer);
      pingTimer = null;
    }
    if (!socket) return;
    socket.onopen = null;
    socket.onmessage = null;
    socket.onerror = null;
    socket.onclose = null;
    socket.close();
    socket = null;
  };

  const connect = () => {
    if (closed) return;
    dropSocket();
    socket = new WebSocket(getWsUrl());

    socket.onopen = () => {
      retryMs = 500;
      socket?.send(JSON.stringify({ type: 'hello', role }));
      pingTimer = setInterval(() => {
        if (socket?.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify({ type: 'ping' }));
        }
      }, PING_MS);
    };

    socket.onmessage = (event) => {
      try {
        const message = JSON.parse(String(event.data)) as {
          type?: string;
          payload?: SessionState;
        };
        if (message.type === 'state' && message.payload) {
          onState(message.payload);
        }
      } catch {
        // битый кадр
      }
    };

    socket.onclose = () => {
      dropSocket();
      if (closed) return;
      retryTimer = setTimeout(connect, retryMs);
      retryMs = Math.min(retryMs * 2, 8000);
    };

    socket.onerror = () => {
      socket?.close();
    };
  };

  connect();

  return () => {
    closed = true;
    if (retryTimer) clearTimeout(retryTimer);
    dropSocket();
  };
}
